module.exports = __webpack_public_path__ + "img/reboot-e.3dab7744.png";